import styled from 'styled-components';
import { Button, Popover } from 'antd';

export const StyledVerticalGap = styled.div`
  height: 20px;
`;

export const StyledStepNum = styled.div`
  float: left;
  width: 34px;
  height: 34px;
  border-radius: 3px 0 0 0;
  background-color: #0093ee;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  line-height: 2.2;
  letter-spacing: normal;
  color: #fff;
`;
export const StyledTable = styled.table`
  width: 870px;
  background: white;
  border: 1px solid #d8e5ef;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 4px;
  overflow: hidden;
  th {
    border-bottom: 1px solid #d8e5ef;
  }
  td {
    /* border: 1px solid #d8e5ef; */
  }
  th {
    background: #fafbfc;
    height: 35px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    padding-right: 15px;
    font-size: 15px;
    line-height: 19px;
    color: #373848;
    vertical-align: top;
    font-weight: 500;
    padding: 7.5px 15px 7.5px 0px;
  }
  th:last-child > span {
    padding-left: 7.5px;
  }
  td {
    padding: 15px;
  }
`;
export const StyledTd = styled.td`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;
export const StyledButtonDisabled = styled(Button)`
  max-width: 140px;
  font-size: 13px;
  color: #627b93;
  background-color: #fff;
  &:hover,
  &:focus {
    /* background-color: #fff; */
    border-color: #d9d9d9;
    color: #627b93;
    cursor: default;
  }
`;

export const StyledNextStepButton = styled(Button)`
  width: 130px;
  height: 32px;
  text-transform: uppercase;
  padding: 1px 15px;
  background: #2075bd;
  color: white;
  /* margin-top: 20px; */
  text-shadow: none;
  box-shadow: none;
  font-weight: 400;
  font-size: 14px;
  border-radius: 4px;
  &:hover,
  &:focus {
    background-color: #125c9b;
    color: white;
  }
`;

export const StyledTitle = styled.h4`
  height: 17px;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.55;
  color: #717585;
  margin-left: 5px;
  margin-bottom: 4px;
`;

export const StyledPopover = styled(Popover)``;
